import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/business/leads/artifacts/")({
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/sales/leads/artifacts", search, replace: true });
    },
});
